/**
 * A sale event hub (web plan W0.15 / W3.4) as a route module (web plan W4.5): `/{cc}/{lang}/sale/:event`,
 * registered in src/routes.ts.
 *
 * The server loader reads the SEO server's answer for the URL (status,
 * redirect, head and the page's query answers; @/seo/pageDocument), so the
 * document's body is the real page, not a loading state. In-app navigations
 * load through Apollo, as before.
 */
import type { LoaderFunctionArgs } from 'react-router';
import { PageRoute } from '@/components/seo/PageRoute';
import { RouteErrorBoundary } from '@/components/seo/RouteErrorBoundary';
import { useRouteLocale } from '@/hooks/useRouteLocale';
import SaleEventPage from '@/pages/SaleEventPage';
import { loadPageDocument, pageClientLoader, pageHeaders, pageMeta } from '@/seo/pageDocument';

export function loader({ context }: LoaderFunctionArgs) {
  return loadPageDocument(context);
}

export function clientLoader() {
  return pageClientLoader();
}

/** The document uses the server loader's data; only in-app navigations run `clientLoader`. */
clientLoader.hydrate = false as const;

export const headers = pageHeaders;

export const meta = pageMeta;

export const ErrorBoundary = RouteErrorBoundary;

export default function SaleRoute() {
  return (
    <PageRoute>
      <SaleEventPage locale={useRouteLocale()} />
    </PageRoute>
  );
}
